<template>
  <div class="modal fade" :id="id" tabindex="-1" ref="confirmModalDanger" aria-labelledby="confirmModalDangerLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body text-center">
          <div class="row py-3 align-items-center">
            <div class="col-auto">
              <i class="bi bi-x-circle-fill text-danger" style="font-size: 2rem;"></i>
            </div>
            <div class="col-auto ps-0 mt-2">
              <h4>{{ t("buttons.warning") }}</h4>
            </div>
          </div>
          <slot></slot>
        </div>

        <div class="modal-footer">
          <button @click.prevent="hide" type="button" class="btn btn-outline-secondary btn-sm rounded-pill">
            {{ t("buttons.cancel") }}
          </button>
          <button @click.prevent="confirmClicked" type="button" class="btn btn-danger btn-sm rounded-pill">
            {{ t("buttons.confirm") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Modal } from "bootstrap";
import { ref, inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const confirmModalDanger = ref<HTMLElement | null>(null);
const modalInstance = ref<Modal | null>(null); // To hold the Bootstrap modal instance
const emitter: any = inject("emitter");
const { t } = useI18n();
const props = defineProps<{
  id: string;
  onConfirm?: () => void;
}>();


defineExpose({
  show,
  hide
});

// Initialize Bootstrap Modal instance after component is mounted
onMounted(() => {
  if (confirmModalDanger.value) {
    modalInstance.value = new Modal(confirmModalDanger.value);
  }
});

function show() {
  modalInstance.value?.show();
}

function hide() {
  modalInstance.value?.hide();
}

function confirmClicked() {
  if (props.onConfirm) {
    props.onConfirm(); // Call the onConfirm prop
  }
  hide();
}

// function confirm() {
//   console.log("Confirming...");
//   // emitter.emit("confirmed");
//   console.log(props.onConfirm)
//   props.onConfirm?.();
//   hide();
// }
</script>

